import AdminHeader from "@/components/common/AdminHeader";
import PermissionGuard from "@/components/common/PermissionGuard";
import SpecialOfferList from "@/components/specialOffers/SpecialOffers";

export default function SpecialOffersPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <PermissionGuard screen="offers">
          <SpecialOfferList />
        </PermissionGuard>
      </main>
    </div>
  );
}